import React, { useState, useEffect } from "react";
import Layout from "../../../Components/Layout/layout";
import dashboardclasses from "../../dashboard.module.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { FaRegEdit } from "react-icons/fa";
import { Services } from "../../../Services";
import AddCity from "./AddCity";
import { css } from "@emotion/react";
import ScaleLoader from "react-spinners/ScaleLoader";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ToastError } from "../../../Components/utils/ToastMessage";

function Cities() {
    const Navigate = useNavigate();

    const [params, setparams] = useSearchParams();
    const [tableLoad, setTableLoad] = useState(false);
    const [pageCount, setpageCount] = useState(1);
    const [showModal, setShowModal] = useState(false);

    const [editable, setEditable] = useState(false);
    const [cityItems, setCityItems] = useState([]);
    const [citySearchItems, setCitySearchItems] = useState([]);

    let [loading, setLoading] = useState(true);
    const token = { Authorization: `token ${sessionStorage.getItem("token")}` };

    const modalHandler = () => {
        setShowModal((prev) => !prev);
    };

    const headerstyles = {
        color: "#707275",
        fontWeight: 700,
        fontSize: "0.8rem",
    };
    const override = css`
        display: block;
        margin: 0 auto;
        border-color: red;
    `;

    const getCities = () => {
        Services.Mobility_GetCities("GET", null, token)
            .then((res) => {
                if (res.Status === 1) {
                    setCityItems(res.Cities);
                    setCitySearchItems(res.Cities);
                    setTableLoad(false);
                    setLoading(false);
                } else if (res.Status === 0) {
                    ToastError(res.Message);
                    if (res.Message === "Token expired") {
                        Navigate("/");
                    }
                }
            })
            .catch((err) => {
                alert("something went wrong please try again");
                console.log(err);
                setTableLoad(false);
            });
    };

    useEffect(() => {
        getCities();
        if (params.get("page")) {
            setpageCount(Number(params.get("page")));
        }
        // eslint-disable-next-line
    }, []);

    const statusFormatter = (cell) => {
        const classname =
            cell === 1
                ? dashboardclasses["status_active"]
                : dashboardclasses["status_inactive"];
        return (
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}>
                <p className={classname}>{cell === 1 ? "Active" : "Inactive"}</p>
            </div>
        );
    };

    const boundaryFormatter = (cell) => `${cell?.length || 0} points`;

    const ActionFormatter = (cell, cellcontent) => {
        return (
            <div className={dashboardclasses.tablebtns}>
                <button
                    onClick={() => {
                        setEditable(cellcontent);
                        setShowModal(true);
                    }}>
                    <FaRegEdit size={18} />
                </button>
            </div>
        );
    };

    const columns = [
        {
            dataField: "city_id",
            text: "ID",
            sort: false,
            headerStyle: () => ({ ...headerstyles }),
        },
        {
            dataField: "city_name",
            text: "CITY",
            sort: false,
            headerStyle: () => ({ ...headerstyles }),
        },
        {
            dataField: "boundary",
            text: "BOUNDARY",
            sort: false,
            formatter: boundaryFormatter,
            headerStyle: () => ({ ...headerstyles }),
        },
        {
            dataField: "city_status",
            text: "STATUS",
            sort: false,
            formatter: statusFormatter,
            headerStyle: () => ({ ...headerstyles }),
        },
        {
            dataField: "ACTIONS",
            text: "ACTIONS",
            sort: false,
            formatter: ActionFormatter,
            headerStyle: () => ({ ...headerstyles, width: "100px" }),
        },
    ];

    const pagination = paginationFactory({
        page: pageCount,
        sizePerPage: 8,
        lastPageText: ">>",
        firstPageText: "<<",
        nextPageText: ">",
        prePageText: "<",
        hideSizePerPage: true,
        showTotal: true,
        alwaysShowAllBtns: true,
        onPageChange: function (page) {
            window.scrollTo({ top: 10, behavior: "instant" });
            Navigate(`/mobility-services/cities?page=${page}`);
        },
    });

    const searchHandler = (e) => {
        setparams({ page: 1 });
        setpageCount(1);
        const search = cityItems.filter((item) =>
            item.city_name.toLowerCase().includes(e.target.value.toLowerCase())
        );
        setCitySearchItems(search);
    };

    return (
        <>
            {showModal && (
                <AddCity
                    setmodal={setShowModal}
                    editable={editable}
                    setEditable={setEditable}
                    getCities={getCities}
                    setpageCount={setpageCount}
                    tableload={setTableLoad}
                />
            )}

            <Layout Active={"mobility_cities"}>
                <div className={dashboardclasses["dashboard-rightside"]}>
                    <div className={dashboardclasses.CategoryWrapper}>
                        <h3>Cities</h3>

                        {loading ? (
                            <div className={dashboardclasses["loader"]}>
                                <ScaleLoader
                                    color={"black"}
                                    loading={true}
                                    css={override}
                                    size={150}
                                />
                            </div>
                        ) : (
                            <>
                                <div
                                    className={
                                        dashboardclasses["category-form-two"]
                                    }>
                                    <input
                                        type={"text"}
                                        placeholder="search by city name"
                                        onChange={searchHandler}
                                    />

                                    <button onClick={modalHandler}>
                                        + Add City
                                    </button>
                                </div>
                                {tableLoad ? (
                                    <div className={dashboardclasses["loader"]}>
                                        <ScaleLoader
                                            color={"black"}
                                            loading={true}
                                            css={override}
                                            size={150}
                                        />
                                    </div>
                                ) : (
                                    <div className="category-table">
                                        <BootstrapTable
                                            bootstrap4
                                            keyField="city_id"
                                            data={citySearchItems}
                                            columns={columns}
                                            pagination={pagination}
                                            wrapperClasses="table-responsive"
                                        />
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </Layout>
        </>
    );
}

export default Cities;
